export default "__VITE_ASSET__4vwvBbBx__"